const types = [
  {
    label: 'Объявление не актуально',
    value: 'not_relevant',
  },
  {
    label: 'Дубликат',
    value: 'duplicate',
  },
  {
    label: 'Это не мое объявление',
    value: 'i_did_not_add_this_ad',
  },
];

export default types;
